import EditableCardEntryState from "./EditableCardEntryState";

const EditableCardEntryStateMultiselect = ({isEditing, onEdit, baseValue, requestSubmission = () => {}, displayLabel = "State"}) => (
    <EditableCardEntryState
        isEditing={isEditing}
        onEdit={onEdit}
        baseValue={baseValue}
        multiselect={true}
        requestSubmission={requestSubmission}
        displayLabel={displayLabel}
    />
)
export default EditableCardEntryStateMultiselect;